export const pickerFlagHeight = '24';
export const chartPickerStyles = {};
